(() => {
  if (window.jeffShoesProductCardReady) return;
  window.jeffShoesProductCardReady = true;

  function handleSwatchActivation(swatch) {
    if (!swatch) return;

    const card = swatch.closest('[data-jeff-product-card]');
    const image = card?.querySelector('[data-jeff-product-image]');
    if (!card || !image) return;

    card.querySelectorAll('[data-jeff-variant-swatch]').forEach((button) => {
      const selected = button === swatch;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
      if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
    }

    const colorNameEl = card.querySelector('[data-jeff-color-name]');
    if (colorNameEl && swatch.dataset.colorName) {
      colorNameEl.textContent = swatch.dataset.colorName;
    }

    if (swatch.dataset.variantUrl) {
      card.querySelectorAll('[data-jeff-product-link]').forEach((link) => {
        link.href = swatch.dataset.variantUrl;
      });
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('[data-jeff-variant-swatch]');
    if (!swatch) return;
    handleSwatchActivation(swatch);
  });

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseenter', (event) => {
      if (!(event.target instanceof Element)) return;
      const swatch = event.target.closest('[data-jeff-variant-swatch]');
      if (!swatch) return;
      handleSwatchActivation(swatch);
    }, true);
  }
})();
